import { Injectable } from '@angular/core';
import { AuthData } from '../providers/auth';
import { AngularFireDatabase } from "angularfire2/database";
import { IEvent } from '../models/client.model';
import { Observable } from 'rxjs/Observable';
import { ISponsorEvent, ISponsorClient } from '../models/sponsor';
import * as firebase from 'firebase';

@Injectable()
export class ClientData {

  constructor(
    public auth: AuthData,
    private afDatabase: AngularFireDatabase,
  ) { }

  _searchClient(token) {
    return this.afDatabase.object(`/ClientList/${token}`).valueChanges();
  }

  searchClient(token, child) {
    let q = firebase.database().ref('/ClientList/').orderByChild(child).equalTo(token.toLowerCase()).limitToFirst(1);

    return new Promise((resolve, reject) => {
      q.once('value').then((snapshot) => {
        if (snapshot.val()) {
          snapshot.forEach(childSnapshot => {
            resolve(childSnapshot.val());
          });
        } else {
          reject(false);
        }
      });
    })
  }

  getEvents(clientId: string) {
    return this.afDatabase.list<IEvent>(`/Clients/${clientId}/EventList`,
      ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  getUsers(clientId: string) {
    return this.afDatabase.list<any>(`/Clients/${clientId}/Users/`).valueChanges()
  }

  getShippingList(clientId: string, shopId: string) {
    return Observable.of([]);
    // TODO: Esto se apaga ya que no se va a utilziar inicialmente
    // return this.afDatabase.list<any>(`/ClientList/${clientId}/shops/${shopId}/shipping_list`).valueChanges()
  }

  getConfigByModule(clientId: string, moduleName: string): Observable<any> {
    return this.afDatabase.object(`ClientList/${clientId}/modules_config/${moduleName}`).valueChanges()
  }

  getConfigByModuleClient(clientId: string, moduleName: string): Observable<any> {
    return this.afDatabase.object(`ClientList/${clientId}/modules_config/${moduleName}`).valueChanges()
  }

  getClientAuthConfig(client_id): Observable<any> {
    return this.afDatabase.object(`/ClientList/${client_id}/AuthConfig`).valueChanges();
  }

  getCategoriesByClient(clientId: string) {
    return this.afDatabase.list<any>(`/ClientList/${clientId}/categories`, ref => {
      return ref.orderByChild('state').equalTo(true)
    }).valueChanges();
  }

  getCategoryName(clientId: string, cat: string) {
    return this.afDatabase.object<any>(`/ClientList/${clientId}/categories/${cat}`).valueChanges();
  }

  getSponsorsEnabled(clientId: string): Observable<ISponsorClient[]> {
    return this.afDatabase.list<ISponsorEvent>(`/ClientList/${clientId}/Sponsor`,
      ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  getSponsorEnabled(clientId: string, idSponsor: string): Observable<ISponsorClient> {
    return this.afDatabase.object<ISponsorClient>(`/ClientList/${clientId}/Sponsor/${idSponsor}`).valueChanges();
  }

  getModuleState(clientId: string, module: string): Observable<boolean> {
    return this.afDatabase.object<boolean>(`/ClientList/${clientId}/modules/${module}`).valueChanges();
  }

  getModuleConfig(clientId: string, module: string): Observable<boolean> {
    return this.afDatabase.object<boolean>(`/ClientList/${clientId}/modules_config/${module}`).valueChanges();
  }

  getReferred(clientId: string): Observable<any> {
    return this.afDatabase.object<boolean>(`/Clients/${clientId}/Referred`).valueChanges();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/client.ts